export const PARTICIPANT_SELECT_UPDATE = "PARTICIPANT_SELECT_UPDATE"
export const PARTICIPANT_DESELECT = "PARTICIPANT_DESELECT"
